<template>
  <div v-if="adminMode" :class="'pane sunset-timesheet-activity ' + prefix">

    <div class="header-row">
      <div>
        <h2 style="margin-bottom: 0.25em;">
          Timesheet Activity Search
        </h2>
        <p style="margin: 0;">
          Search submit, reopen, reset, import and worker activity for this period.
        </p>
      </div>

      <div class="header-actions">
        <router-link :to="activityRoute">
          <button
              class="btn orcaBtn"
              type="button"
              style="width: 170px"
          >
            Open
          </button>
        </router-link>
      </div>
    </div>

    <details class="pane activity-info">
      <summary>
        <strong>What can I search?</strong>
        <span class="help-hint">(click to expand)</span>
      </summary>

      <div class="activity-info-content">
        <ul>
          <li>
            Search activity by week ending date, action type, user ID, worker ID or timesheet ID.
          </li>

          <li>
            Use this when checking who submitted, reopened, reset or dismissed timesheets.
          </li>

          <li>
            Results include the raw action context so support can inspect affected timesheet IDs.
          </li>
        </ul>

        <p style="margin-top: 0.75em;">
          The activity page will open with this selected period pre-filled.
        </p>
      </div>
    </details>
  </div>
</template>

<script>
export default {
  name: 'sunset_timesheet_activity_widget',

  props: {
    prefix: { required: true },
    company_id: { required: true },
    start_date: { required: true },
    end_date: { required: true },
    adminMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    activityRoute() {
      return {
        name: `${this.prefix}_timesheet_activity_search`,
        params: {
          company_id: this.company_id,
          start_date: this.start_date,
          end_date: this.end_date,
        },
      };
    },
  },
};
</script>

<style scoped>
.sunset-timesheet-activity {
  display: grid;
  padding: 1em;
  grid-template-columns: 1fr;
  margin-bottom: 1em;
}

.header-actions {
  display: grid;
  grid-template-columns: 100%;
  justify-content: flex-end;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 1em;
}

.header-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 1em;
  margin-bottom: 1em;
}

.activity-info {
  background-color: #fafafa;
}

.activity-info summary {
  list-style: none;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.activity-info summary::-webkit-details-marker {
  display: none;
}

.help-hint {
  font-size: 0.9em;
  color: #777;
}

.activity-info-content {
  margin-top: 0.75em;
}

.activity-info ul {
  margin: 0;
  padding-left: 1.25em;
}

.activity-info li {
  margin-bottom: 0.5em;
}

.btn {
  width: 170px;
  min-width: 170px;
  background-color: forestgreen;
}

@media (max-width: 1100px) {
  .header-row {
    grid-template-columns: 1fr;
    gap: 0.75em;
  }
}
</style>
